import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldCheck, Check, X, Clock, AlertCircle } from "lucide-react";
import { toast } from "sonner";

export default function AdminVerifications() {
  const [status, setStatus] = useState("pending");
  const [list, setList] = useState([]);
  const [viewing, setViewing] = useState(null);

  const load = () => api.get(`/admin/verifications?status=${status}`).then(({ data }) => setList(data));
  useEffect(() => {
    load();
    const i = setInterval(load, 8000);
    return () => clearInterval(i);
  }, [status]);

  const approve = async (r) => {
    await api.post(`/admin/verifications/${r.id}/approve`);
    toast.success(`Đã duyệt: ${r.real_name}`);
    setViewing(null); load();
  };
  const reject = async (r) => {
    const reason = window.prompt("Lý do từ chối?", "Ảnh không rõ");
    if (!reason) return;
    await api.post(`/admin/verifications/${r.id}/reject`, { reason });
    toast.success("Đã từ chối");
    setViewing(null); load();
  };

  return (
    <div className="p-6 lg:p-8">
      <h1 className="font-display font-bold text-3xl mb-1 flex items-center gap-3"><ShieldCheck className="text-emerald-300" /> Xác thực tài khoản</h1>
      <p className="text-white/40 text-sm mb-6">Duyệt yêu cầu xác thực CCCD của người chơi</p>

      <div className="flex gap-2 mb-5">
        {["pending", "approved", "rejected"].map((s) => (
          <button key={s} onClick={() => setStatus(s)} data-testid={`vtab-${s}`}
            className={`px-4 py-2 rounded-md text-sm ${status === s ? "bg-cyan-400/10 text-cyan-300 border border-cyan-400/40" : "bg-white/[0.03] text-white/60 border border-white/8"}`}>
            {s === "pending" ? "Chờ duyệt" : s === "approved" ? "Đã duyệt" : "Từ chối"}
          </button>
        ))}
      </div>

      <div className="rounded-xl bg-[#0c0d14] border border-white/8 overflow-hidden">
        {list.length === 0 ? (
          <div className="py-12 text-center text-white/40 text-sm">Không có yêu cầu</div>
        ) : list.map((r) => (
          <div key={r.id} className="flex items-center gap-3 p-4 border-b border-white/5 hover:bg-white/[0.03]" data-testid={`vreq-${r.id}`}>
            <img src={r.user_avatar} alt="" className="w-10 h-10 rounded-full" />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium">{r.real_name} <span className="text-white/40 ml-1">@{r.user_nickname}</span></div>
              <div className="text-xs text-white/40">SĐT: {r.phone} · CCCD: {r.cccd_number} · {new Date(r.submitted_at).toLocaleString("vi-VN")}</div>
              {r.status === "rejected" && r.reject_reason && <div className="text-xs text-red-300 mt-0.5">Lý do: {r.reject_reason}</div>}
            </div>
            <button onClick={() => setViewing(r)} data-testid={`view-${r.id}`} className="px-3 py-1.5 rounded text-xs border border-white/10 hover:bg-white/5">Xem ảnh</button>
            {r.status === "pending" && (
              <>
                <button onClick={() => approve(r)} data-testid={`approve-${r.id}`} className="px-3 py-1.5 rounded text-xs bg-emerald-500/15 text-emerald-300 border border-emerald-500/30 flex items-center gap-1"><Check size={11} /> Duyệt</button>
                <button onClick={() => reject(r)} data-testid={`reject-${r.id}`} className="px-3 py-1.5 rounded text-xs bg-red-500/10 text-red-300 border border-red-500/30 flex items-center gap-1"><X size={11} /> Từ chối</button>
              </>
            )}
          </div>
        ))}
      </div>

      {viewing && (
        <div className="fixed inset-0 z-50 grid place-items-center p-4 bg-black/85 backdrop-blur-sm" onClick={() => setViewing(null)}>
          <div className="w-full max-w-4xl rounded-xl bg-[#0c0d14] border border-white/10 p-6 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-display font-semibold">{viewing.real_name} — Ảnh xác thực</h3>
              <button onClick={() => setViewing(null)}><X size={16} /></button>
            </div>
            <div className="grid sm:grid-cols-3 gap-3">
              {[["CCCD mặt trước", "cccd_front_image"], ["CCCD mặt sau", "cccd_back_image"], ["Selfie", "selfie_image"]].map(([l, k]) => (
                <div key={k}>
                  <div className="text-[10px] uppercase tracking-wider text-white/50 mb-1.5">{l}</div>
                  <img src={viewing[k]} alt={l} className="w-full rounded border border-white/10" />
                </div>
              ))}
            </div>
            {viewing.status === "pending" && (
              <div className="flex gap-2 mt-4 justify-end">
                <button onClick={() => reject(viewing)} className="px-4 py-2 rounded text-sm bg-red-500/10 text-red-300 border border-red-500/30">Từ chối</button>
                <button onClick={() => approve(viewing)} className="px-4 py-2 rounded text-sm bg-emerald-500/15 text-emerald-300 border border-emerald-500/30">Duyệt</button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
